import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8" };
const _hoisted_2 = { class: "flex flex-col gap-2 md:flex-row md:items-end md:justify-between" };
const _hoisted_3 = {
    key: 0,
    class: "text-xs uppercase tracking-[0.3em] text-gray-500"
};
const _hoisted_4 = { class: "text-3xl lg:text-4xl font-bold text-gray-900 mt-1" };
const _hoisted_5 = {
    key: 1,
    class: "text-base lg:text-lg text-gray-600 max-w-2xl"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" };
const _hoisted_8 = { class: "flex items-center gap-3" };
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "text-right w-full" };
const _hoisted_12 = { class: "text-lg font-semibold text-slate-900" };
const _hoisted_13 = { class: "text-xs text-slate-500" };
const _hoisted_14 = {
    key: 0,
    class: "hidden lg:block mt-2 text-sm text-slate-500"
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    ...{ name: 'CategoryHighlights' },
    __name: 'CategoryHighlights',
    props: {
        heading: {},
        subheading: {},
        description: {},
        ctaLabel: {},
        ctaHref: {},
        categories: {}
    },
    setup(__props) {
        const props = __props;
        const headingText = computed(() => props.heading ?? 'Our Categories');
        const categories = computed(() => props.categories ?? []);
        const ctaHref = computed(() => props.ctaHref ?? '#');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", null, [
                            (props.subheading)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.subheading), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(headingText.value), 1 /* TEXT */),
                            (props.description)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.description), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        (props.ctaLabel)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: ctaHref.value,
                                class: "mt-4 inline-flex items-center justify-center rounded-full border border-red-500 px-5 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-500 hover:text-white"
                            }, _toDisplayString(props.ctaLabel), 9 /* TEXT, PROPS */, _hoisted_6))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                            return (_openBlock(), _createBlock(_resolveDynamicComponent(category.link ? 'a' : 'article'), {
                                key: category.name,
                                href: category.link,
                                target: category.linkTarget,
                                rel: category.link && category.linkTarget === '_blank' ? 'noreferrer' : undefined,
                                class: "rounded-2xl border border-slate-200 bg-white px-5 py-6 shadow-lg transition hover:-translate-y-0.5 hover:shadow-2xl"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("span", {
                                            class: "flex h-20 items-center justify-center rounded-2xl text-xl overflow-hidden",
                                            style: _normalizeStyle(category.iconBackground ? { backgroundColor: category.iconBackground } : {})
                                        }, [
                                            (category.image)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: category.image,
                                                    alt: category.name,
                                                    class: "w-full object-cover"
                                                }, null, 8 /* PROPS */, _hoisted_9))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(category.icon), 1 /* TEXT */))
                                        ], 4 /* STYLE */),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("h3", _hoisted_12, _toDisplayString(category.name), 1 /* TEXT */),
                                            _createElementVNode("p", _hoisted_13, _toDisplayString(category.itemCount), 1 /* TEXT */)
                                        ])
                                    ]),
                                    (category.description)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(category.description), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href", "target", "rel"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "block md:hidden border-b border-slate-200 border-4" }, null, -1 /* CACHED */))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
